/**
 * Misc admin API endpoints (Step 7.1.16).
 *
 * Cross-cutting admin endpoints without a dedicated domain:
 * portfolio map (property coordinates) and audit logs (entity history).
 * Extracted from adminData/index.js for team scalability.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  parseAdminErrorResponse,
} from "./core";

/**
 * GET /api/admin/portfolio-map — operational map rows (property coordinates + map status).
 * @param {{ businessApartmentsOnly?: boolean }} [opts]
 */
export function fetchAdminPortfolioMap(opts = {}) {
  const sp = new URLSearchParams();
  if (opts.businessApartmentsOnly) {
    sp.set("business_apartments_only", "true");
  }
  const qs = sp.toString();
  const url = `${API_BASE_URL}/api/admin/portfolio-map${qs ? `?${qs}` : ""}`;
  return fetch(url, { headers: getApiHeaders() }).then(async (res) => {
    if (!res.ok) {
      throw new Error(await parseAdminErrorResponse(res));
    }
    return res.json();
  });
}

/**
 * Audit log entries for an entity (e.g. unit). GET /api/admin/audit-logs
 */
export function fetchAdminAuditLogs(params) {
  const sp = new URLSearchParams();
  sp.set("entity_type", params.entity_type);
  sp.set("entity_id", params.entity_id);
  const url = `${API_BASE_URL}/api/admin/audit-logs?${sp.toString()}`;
  return fetch(url, { headers: getApiHeaders() }).then((res) => {
    if (!res.ok) throw new Error("Verlauf konnte nicht geladen werden.");
    return res.json();
  });
}
